<div class="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
  <div class="modal-header bg-gradient text-white">
    <h5 class="modal-title fw-bold">
      <i class="bi bi-trash3-fill me-2"></i> Eliminar Fuente
    </h5>
    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
  </div>

  <!-- Estado: Confirmación -->
  @if (!loading() && !success() && !error()) {
    <div class="modal-body text-center py-5">
      <div class="delete-icon mb-3">
        <i class="bi bi-exclamation-triangle-fill text-danger" style="font-size: 3.5rem;"></i>
      </div>
      <h5 class="fw-semibold mb-3 text-dark">
        ¿Seguro que deseas eliminar esta fuente?
      </h5>
      <p class="text-muted mb-0">
        Se eliminará el registro de
        <strong class="text-primary">{{ fountain?.nombre }}</strong>.
      </p>
    </div>
  }

  <!-- Estado: Cargando -->
  @if (loading()) {
    <div class="modal-body text-center py-5">
      <div class="spinner-border text-danger mb-3" role="status"></div>
      <h6 class="fw-semibold">Eliminando fuente...</h6>
    </div>
  }

  <!-- Estado: Éxito -->
  @if (success()) {
    <div class="modal-body text-center py-5">
      <i class="bi bi-check-circle-fill text-success" style="font-size: 3.5rem;"></i>
      <h5 class="fw-semibold mt-3">Fuente eliminada correctamente</h5>
    </div>
  }

  <!-- Estado: Error -->
  @if (error()) {
    <div class="modal-body text-center py-5">
      <i class="bi bi-x-circle-fill text-danger" style="font-size: 3.5rem;"></i>
      <h5 class="fw-semibold mt-3">Ocurrió un error al eliminar la fuente</h5>
    </div>
  }

  <!-- Footer -->@if (!loading()) {
  <div class="modal-footer justify-content-center border-0 pb-4">
    @if (!success() && !error()) {
      <button
        type="button"
        class="btn btn-danger text-white px-4 py-2 shadow-sm"
        data-bs-dismiss="modal"
      >
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>

      <button
        type="button"
        class="btn btn-danger px-4 py-2 shadow-sm"
        (click)="confirmDelete()"
      >
        <i class="bi bi-trash me-1"></i> Eliminar
      </button>
    }

    @if (success() || error()) {
      <button
        type="button"
        class="btn btn-danger text-white px-4"
        data-bs-dismiss="modal"
      >
        <i class="bi bi-arrow-left-circle me-1"></i> Cerrar
      </button>
    }
  </div>
}
